<template>
  <div class="home">
    <!-- 轮播图 -->
    <section class="carousel-section">
      <div class="carousel-container">
        <div v-for="(slide, index) in carouselSlides" 
             :key="index" 
             class="carousel-slide"
             :class="{ active: currentSlide === index }">
          <img :src="config.imageUrl + slide.image" :alt="slide.title">
          <div class="carousel-caption">
            <h2>{{ slide.title }}</h2>
            <p>{{ slide.description }}</p>
            <!-- <router-link :to="slide.link" class="btn btn-primary">了解更多</router-link> -->
          </div>
        </div>
        <div class="carousel-controls" v-if="carouselSlides.length > 1">
          <button class="carousel-prev" @click="prevSlide">
            <i class="fas fa-chevron-left"></i>
          </button>
          <div class="carousel-indicators">
            <span v-for="(_, index) in carouselSlides" 
                  :key="index"
                  class="indicator"
                  :class="{ active: currentSlide === index }"
                  @click="currentSlide = index">
            </span>
          </div>
          <button class="carousel-next" @click="nextSlide">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </section>

    <!-- 公司简介 -->
    <section class="company-intro">
      <div class="container">
        <div class="section-header">
          <h2>公司愿景</h2>
          <div class="section-divider"></div>
        </div>
        <div class="intro-content">
          <div v-for="(item, index) in introItems" 
               :key="index" 
               class="intro-card">
            <div class="intro-icon">
              <i :class="item.icon"></i>
            </div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品展示 -->
    <section class="product-showcase">
      <div class="container">
        <div class="section-header">
          <h2>产品展示</h2>
          <div class="section-divider"></div>
        </div>
        <div class="product-grid">
          <div v-for="(product, index) in products" 
               :key="index" 
               class="product-card">
            <div class="product-image">
              <img :src="config.imageUrl +  product.image" :alt="product.title">
            </div>
            <div class="product-info">
              <h3>{{ product.title }}</h3>
              <p>{{ product.description }}</p>
              <router-link :to="product.link" class="btn btn-outline">查看详情</router-link>
            </div>
          </div>
        </div>
        <div class="view-more">
          <!-- <router-link to="/products" class="btn btn-primary">查看更多产品</router-link> -->
        </div>
      </div>
    </section>

    <!-- 应用场景 -->
    <section class="application-section">
      <div class="container">
        <div class="section-header">
          <h2>应用场景</h2>
          <div class="section-divider"></div>
        </div>
        <div class="application-grid">
          <div v-for="(app, index) in applications" 
               :key="index" 
               class="application-card">
            <div class="application-image">
              <img :src="config.imageUrl + app.image" :alt="app.title">
            </div>
            <div class="application-overlay">
              <h3>{{ app.title }}</h3>
              <p>{{ app.description }}</p>
              <router-link :to="app.link" class="btn btn-light">了解更多</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 新闻资讯 -->
    <!-- <section class="news-section">
      <div class="container">
        <div class="section-header">
          <h2>新闻资讯</h2>
          <div class="section-divider"></div>
        </div>
        <div class="news-grid">
          <div v-for="(news, index) in newsItems" 
               :key="index" 
               class="news-card">
            <div class="news-date">
              <span class="day">{{ news.day }}</span>
              <span class="month">{{ news.month }}</span>
              <span class="year">{{ news.year }}</span>
            </div>
            <div class="news-content">
              <h3>{{ news.title }}</h3>
              <p>{{ news.description }}</p>
              <router-link :to="news.link" class="news-link">
                阅读更多 <i class="fas fa-arrow-right"></i>
              </router-link>
            </div>
          </div>
        </div>
        <div class="view-more">
          <router-link to="/news" class="btn btn-primary">查看更多新闻</router-link>
        </div>
      </div>
    </section> -->

    <!-- 固定按钮组 -->
    <div class="fixed-buttons">
      <el-popover
        placement="left"
        :width="280"
        trigger="click"
        popper-class="contact-popover"
      >
        <template #reference>
          <div class="fixed-button contact-button">
            <i class="fas fa-phone-alt"></i>
            <span>联系我们</span>
          </div>
        </template>
        <div class="contact-content">
          <h4>联系方式</h4>
          <p><i class="fas fa-phone"></i> 电话：{{ companyInfo.phone }}</p>
          <!-- <p><i class="fas fa-mobile-alt"></i> 手机：138-8888-8888</p> -->
          <p><i class="fas fa-envelope"></i> 邮箱：{{companyInfo.email}}</p>
        </div>
      </el-popover>

      <div class="fixed-button back-to-top" @click="scrollToTop" v-show="showBackToTop">
        <i class="fas fa-arrow-up"></i>
        <span>返回顶部</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { ElPopover } from 'element-plus'
import 'element-plus/dist/index.css'
import { otherApi } from '@/api/otherApi'
import { getCompanyInfo } from '@/utils/constant'
import config from '@/config'
const companyInfo = ref({}) 
getCompanyInfo().then(res => {
  companyInfo.value = res
})

// 轮播图数据
const carouselSlides = ref([])

//获取轮播图数据
function getBanner() {
  otherApi.getBanner({type: 0 ,pageSize:5}).then(res => {
    if (res && res.data) {
      carouselSlides.value = res.data
    }
  }).catch(error => {
    console.error('获取轮播图数据失败:', error)
  })
}

const products = ref([])
//获取产品展示数据
function getBanner1() {
  otherApi.getBanner({type: 1 ,pageSize:3}).then(res => {
    if (res && res.data) {
      products.value = res.data
    }
  }).catch(error => {
    console.error('获取产品数据失败:', error)
  })
}
// 应用场景数据
const applications = ref([])
function getBanner2() {
  otherApi.getBanner({type: 2 ,pageSize:2}).then(res => {
    if (res && res.data) {
      applications.value = res.data
    }
  }).catch(error => {
    console.error('获取产品数据失败:', error)
  })
}
// 在组件挂载时获取数据
onMounted(() => {
  getBanner()
  getBanner1()
  getBanner2()
  getBanner4()
})
const introItems = ref([]);
function getBanner4() {
  otherApi.getBanner({type: 104 ,pageSize:3}).then(res => {
    if (res && res.data) {
      introItems.value = res.data
    }
  })
}
// 新闻数据
const newsItems = [
  {
    day: '15',
    month: '6月',
    year: '2023',
    title: '我司成功获得国家高新技术企业认证',
    description: '近日，我司凭借强大的研发实力和创新能力，成功获得国家高新技术企业认证，标志着公司的技术水平和创新能力得到国家认可。',
    link: '/news'
  },
  {
    day: '28',
    month: '5月',
    year: '2023',
    title: '智能测温技术在工业领域的应用与发展',
    description: '随着工业4.0时代的到来，智能测温技术在工业领域的应用日益广泛。本文将探讨智能测温技术的最新发展趋势及其在工业领域的应用前景。',
    link: '/news'
  }
]

// 轮播图控制
const currentSlide = ref(0)
let slideInterval

const nextSlide = () => {
  if (carouselSlides.value.length <= 1) return
  currentSlide.value = (currentSlide.value + 1) % carouselSlides.value.length
}

const prevSlide = () => {
  if (carouselSlides.value.length <= 1) return
  currentSlide.value = (currentSlide.value - 1 + carouselSlides.value.length) % carouselSlides.value.length
}

const startSlideShow = () => {
  if (carouselSlides.value.length <= 1) return
  slideInterval = setInterval(nextSlide, 5000)
}

const stopSlideShow = () => {
  if (slideInterval) {
    clearInterval(slideInterval)
  }
}

// 返回顶部功能
const showBackToTop = ref(false)

const handleScroll = () => {
  showBackToTop.value = window.scrollY > 300
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

onMounted(() => {
  startSlideShow()
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  stopSlideShow()
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style lang="scss" scoped>
.home {
  .carousel-section {
    position: relative;
    height: 600px;
    overflow: hidden;

    .carousel-container {
      position: relative;
      height: 100%;

      .carousel-slide {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        transition: opacity 0.5s ease;

        &.active {
          opacity: 1;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .carousel-caption {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          text-align: center;
          color: #fff;
          width: 80%;
          max-width: 800px;

          h2 {
            font-size: 48px;
            margin-bottom: 20px;
            text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
          }

          p {
            font-size: 20px;
            margin-bottom: 30px;
            text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
          }
        }
      }

      .carousel-controls {
        position: absolute;
        bottom: 30px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        gap: 20px;

        .carousel-prev,
        .carousel-next {
          width: 40px;
          height: 40px;
          border: none;
          background-color: rgba(255, 255, 255, 0.3);
          color: #fff;
          border-radius: 50%;
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            background-color: rgba(255, 255, 255, 0.5);
          }
        }

        .carousel-indicators {
          display: flex;
          gap: 10px;

          .indicator {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background-color: rgba(255, 255, 255, 0.3);
            cursor: pointer;
            transition: all 0.3s ease;

            &.active {
              background-color: #fff;
            }
          }
        }
      }
    }
  }

  .company-intro {
    padding: 80px 0;
    background-color: #fff;

    .intro-content {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 30px;
      margin-top: 40px;

      .intro-card {
        text-align: center;
        padding: 30px;
        border-radius: 8px;
        background-color: #f8f9fa;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
          background-color: #fff;
        }

        .intro-icon {
          width: 80px;
          height: 80px;
          margin: 0 auto 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #1890ff;
          border-radius: 50%;
          color: #fff;
          font-size: 32px;
        }

        h3 {
          font-size: 20px;
          color: #333;
          margin-bottom: 15px;
        }

        p {
          color: #666;
          font-size: 14px;
          line-height: 1.6;
        }
      }
    }
  }

  .product-showcase {
    padding: 80px 0;
    background-color: #f5f5f5;

    .product-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 30px;
      margin-top: 40px;

      .product-card {
        background-color: #fff;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        }

        .product-image {
          height: 200px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s ease;
          }
        }

        .product-info {
          padding: 20px;

          h3 {
            font-size: 18px;
            color: #333;
            margin-bottom: 10px;
          }

          p {
            color: #666;
            font-size: 14px;
            line-height: 1.6;
            margin-bottom: 15px;
          }
        }
      }
    }

    .view-more {
      text-align: center;
      margin-top: 40px;
    }
  }

  .application-section {
    padding: 80px 0;
    background-color: #fff;

    .application-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 30px;
      margin-top: 40px;

      .application-card {
        position: relative;
        height: 300px;
        border-radius: 8px;
        overflow: hidden;

        .application-image {
          width: 100%;
          height: 100%;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s ease;
          }
        }

        .application-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          padding: 30px;
          color: #fff;
          opacity: 0;
          transition: opacity 0.3s ease;

          h3 {
            font-size: 24px;
            margin-bottom: 10px;
          }

          p {
            font-size: 14px;
            margin-bottom: 20px;
            opacity: 0.8;
          }
        }

        &:hover {
          .application-image img {
            transform: scale(1.05);
          }

          .application-overlay {
            opacity: 1;
          }
        }
      }
    }
  }

  .news-section {
    padding: 80px 0;
    background-color: #f5f5f5;

    .news-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 30px;
      margin-top: 40px;

      .news-card {
        display: flex;
        background-color: #fff;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        }

        .news-date {
          padding: 20px;
          background-color: #1890ff;
          color: #fff;
          text-align: center;
          min-width: 100px;

          .day {
            display: block;
            font-size: 24px;
            font-weight: bold;
          }

          .month, .year {
            display: block;
            font-size: 14px;
          }
        }

        .news-content {
          padding: 20px;
          flex: 1;

          h3 {
            font-size: 18px;
            color: #333;
            margin-bottom: 10px;
          }

          p {
            color: #666;
            font-size: 14px;
            line-height: 1.6;
            margin-bottom: 15px;
          }

          .news-link {
            color: #1890ff;
            text-decoration: none;
            font-size: 14px;
            display: flex;
            align-items: center;
            gap: 5px;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }

    .view-more {
      text-align: center;
      margin-top: 40px;
    }
  }
}

// 响应式布局
@media (max-width: 1400px) {
  .home {
    .product-showcase {
      .product-grid {
        grid-template-columns: repeat(3, 1fr);
      }
    }
  }
}

@media (max-width: 1200px) {
  .home {
    .carousel-section {
      height: 500px;

      .carousel-container {
        .carousel-slide {
          .carousel-caption {
            h2 {
              font-size: 36px;
            }

            p {
              font-size: 18px;
            }
          }
        }
      }
    }

    .company-intro {
      .intro-content {
        grid-template-columns: repeat(2, 1fr);
      }
    }

    .product-showcase {
      .product-grid {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }
}

@media (max-width: 992px) {
  .home {
    .carousel-section {
      height: 400px;

      .carousel-container {
        .carousel-slide {
          .carousel-caption {
            h2 {
              font-size: 32px;
            }

            p {
              font-size: 16px;
            }
          }
        }
      }
    }

    .application-section {
      .application-grid {
        grid-template-columns: 1fr;

        .application-card {
          height: 250px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .home {
    .carousel-section {
      height: 350px;

      .carousel-container {
        .carousel-slide {
          .carousel-caption {
            h2 {
              font-size: 28px;
            }

            p {
              font-size: 14px;
            }
          }
        }

        .carousel-controls {
          bottom: 20px;

          .carousel-prev,
          .carousel-next {
            width: 32px;
            height: 32px;
          }

          .carousel-indicators {
            .indicator {
              width: 8px;
              height: 8px;
            }
          }
        }
      }
    }

    .company-intro {
      padding: 40px 0;

      .intro-content {
        grid-template-columns: 1fr;
      }
    }

    .product-showcase {
      padding: 40px 0;

      .product-grid {
        grid-template-columns: 1fr;
      }
    }

    .application-section {
      padding: 40px 0;
    }

    .news-section {
      padding: 40px 0;

      .news-grid {
        grid-template-columns: 1fr;

        .news-card {
          flex-direction: column;

          .news-date {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            padding: 15px;

            .day, .month, .year {
              display: inline;
            }
          }
        }
      }
    }

    .fixed-buttons {
      right: 10px;
      bottom: 10px;

      .fixed-button {
        width: 40px;
        height: 40px;

        i {
          font-size: 16px;
        }

        span {
          display: none;
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .home {
    .carousel-section {
      height: 300px;

      .carousel-container {
        .carousel-slide {
          .carousel-caption {
            h2 {
              font-size: 24px;
            }

            p {
              font-size: 12px;
            }
          }
        }
      }
    }

    .section-header {
      h2 {
        font-size: 24px;
      }
    }
  }
}

.fixed-buttons {
  position: fixed;
  right: 20px;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1000;

  .fixed-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    background: #1890ff;
    color: white;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
      background: #40a9ff;

      span {
        opacity: 1;
        transform: translateX(0);
      }
    }

    i {
      font-size: 20px;
    }

    span {
      position: absolute;
      right: 60px;
      background: #1890ff;
      padding: 5px 10px;
      border-radius: 4px;
      font-size: 14px;
      white-space: nowrap;
      opacity: 0;
      transform: translateX(10px);
      transition: all 0.3s ease;
      pointer-events: none;

      &::after {
        content: '';
        position: absolute;
        right: -5px;
        top: 50%;
        transform: translateY(-50%);
        border-left: 5px solid #1890ff;
        border-top: 5px solid transparent;
        border-bottom: 5px solid transparent;
      }
    }
  }

  .contact-button {
    background: #52c41a;

    &:hover {
      background: #73d13d;
    }

    span::after {
      border-left-color: #52c41a;
    }
  }
}

.contact-content {
  padding: 15px;

  h4 {
    margin: 0 0 15px;
    color: #333;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
  }

  p {
    margin: 12px 0;
    color: #666;
    font-size: 15px;
    display: flex;
    align-items: center;
    gap: 10px;
    white-space: nowrap;

    i {
      color: #1890ff;
      width: 20px;
      font-size: 16px;
    }
  }
}
</style>

<script>
export default {
  name: 'HomePage'
}
</script> 